import { useState, useContext } from "react";
import { TooltipRenderProps } from "react-joyride";
import classNames from "classnames";

import FormInput from "./form-input";

import GuideTourContext from "../context/GuideTourContext";

const CustomTooltip = (props: TooltipRenderProps) => {
  const [doNotShow, setDoNotShow] = useState(false);
  const {
    backProps,
    // closeProps,
    continuous,
    index,
    primaryProps,
    skipProps,
    step,
    tooltipProps,
  } = props;

  const TourData = useContext(GuideTourContext);

  const isNextDisabled =
    primaryProps.title === "Next" && TourData?.disableNextBtn;

  return (
    <div className="tooltip__body" {...tooltipProps}>
      <button className="tooltip__close" onClick={skipProps.onClick}>
        &times;
      </button>
      {step.title && <h4 className="tooltip__title">{step.title}</h4>}
      <div className="tooltip__content">
        <p>{step.content}</p>
      </div>
      <div className="tooltip__footer">
        {/* <button className="tooltip__button" {...skipProps}>
          {skipProps.title}
        </button> */}
        <FormInput
          id="do-not-show"
          label={
            <>
              <span {...skipProps}>Don’t show me this again</span>
            </>
          }
          type="checkbox"
          value={doNotShow}
          onChange={() => setDoNotShow(!doNotShow)}
          readOnly={false}
        />
        <div className="tooltip__spacer">
          {index > 0 && !TourData?.hideBackBtn && (
            <button
              className="tooltip__button tooltip__button--back"
              {...backProps}
            >
              {backProps.title}
            </button>
          )}
          {continuous && (
            <button
              disabled={isNextDisabled}
              className={classNames(
                "tooltip__button tooltip__button--primary",
                { disabled: isNextDisabled }
              )}
              {...primaryProps}
            >
              {primaryProps.title === "Last" ? "Done" : primaryProps.title}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomTooltip;
